var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-card rounded-lg",class:{ 'shadow-soft': _vm.witdShadow }},[_c('div',{staticClass:"mdmax:h-auto"},[_vm._t("image")],2),_c('div',{staticClass:"p-3 bg-white text-left rounded-b-lg",class:{ 'border border-grey-field': _vm.withBorder }},[_vm._t("description")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }